import { app_url } from "app_config"
import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import {
  Container,
  CardBody,
  Card,
  UncontrolledAccordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Col,
  Row,
} from "reactstrap"
import AllStatusMaster from "./Status Master"
import AllSingleItems from "../Single Item Master"
import { usePermissionData } from "AppContext"

const WorkFlowMaster = () => {
  const { tab_name } = useParams()
  const navigate = useNavigate()

  document.title = "WorkFlow Master | Peacock Accountants Limited"

  const { checkAccess, permissions } = usePermissionData()

  const [tabs, setTabs] = useState([])

  useEffect(() => {
    if (permissions) {
      const newTabs = []
      if (checkAccess(8, "view")) newTabs.push("client-status")
      if (checkAccess(9, "view")) newTabs.push("status-master")
      if (checkAccess(10, "view")) newTabs.push("work-type")

      setTabs(newTabs) // Update the state with the new array
    }
  }, [permissions])

  useEffect(() => {
    if (!tab_name && tabs.length) {
      navigate(`${app_url}master/workflow-master/${tabs[0]}`)
    }
  }, [tab_name, tabs])

  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"WorkFlow Master"} />
          <div>
            <Row>
              <Col md={2} className="pe-1">
                <Card>
                  <CardBody className=" rounded custom_side_nav p-2">
                    {tabs.map(tab => {
                      return (
                        <div key={tab} className="mb-2">
                          <Link
                            to={`${app_url}master/workflow-master/${tab}`}
                            className={`side_navlink text-capitalize ${
                              tab === tab_name && "bg-white fw-bold"
                            }`}
                          >
                            {tab.replaceAll("-", " ")}
                          </Link>
                        </div>
                      )
                    })}
                  </CardBody>
                </Card>
              </Col>
              <Col md={10}>
                <Card>
                  <CardBody>
                    {tab_name === "client-status" && (
                      <AllStatusMaster
                        api_name="client-status"
                        heading={"Client Status"}
                        type="Client"
                        module_id={8}
                      />
                    )}

                    {tab_name === "status-master" && (
                      <AllStatusMaster
                        api_name="status-master"
                        heading={"Status Master"}
                        type=""
                        module_id={9}
                      />
                    )}

                    {tab_name === "work-type" && (
                      <AllSingleItems
                        api_name={"work-type"}
                        heading={"Work Type"}
                        title={"Work Type"}
                        fieldName={"workType"}
                        module_id={10}
                      />
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default WorkFlowMaster
